import { render, staticRenderFns } from "./IconsSvg.vue?vue&type=template&id=6d27b620&"
import script from "./IconsSvg.vue?vue&type=script&lang=js&"
export * from "./IconsSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports